import { JsonDeserializable } from '../../rest/JsonDeserealizable';

export class TitulosResponsive extends JsonDeserializable {
  titleDesktop: string;
  titleTablet: string;
  titleMobile: string;

  constructor(titleDesktop?: string, titleTablet?: string, titleMobile?: string) {
    super();
    this.titleDesktop = titleDesktop ? titleDesktop : '';
    this.titleTablet = titleTablet ? titleTablet : '';
    this.titleMobile = titleMobile ? titleMobile : '';
  }
}